import React from "react";

const CreateAccountComponent = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1>404</h1>
        <h2>Oops! Page not found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <a href="/" className="back-home">
          Go to Homepage
        </a>
      </div>
    </div>
  );
};

export default CreateAccountComponent;
